export default __webpack_public_path__ + "static/media/slide_11.dae1caf2.jpg";